import * as React from 'react';
import Slider from "../components/Slider";
export default function useComponent(components) {
  return React.useMemo(function () {
    var _ref = components || {},
      slider = _ref.slider;
    return [slider || Slider];
  }, [components]);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rc-component/color-picker/es/hooks/useComponent.js
// module id = 1537
// module chunks = 0